import Links from './link-mixin';

export {
  Links,
};
